import { BookmarkAltIcon, LibraryIcon, MapIcon } from '@heroicons/react/outline';
import Image from 'next/image';
import Link from 'next/link';

const supportLinks = [
  {
    name: 'Kataloguj',
    href: '/blog',
    description:
      'Naklej kod, zeskanuj telefonem, przyporządkuj ISBN, to proste. Gromadź książki, nadzoruj stan swojego zbioru.',
    icon: LibraryIcon,
  },
  {
    name: 'Wymieniaj się',
    href: '/blog',
    description:
      'Kupiłeś książkę od kogoś? Ktoś Ci dał? Zeskanuj skatalogowaną książkę i dodaj do swojej kolekcji.',
    icon: BookmarkAltIcon,
  },
  {
    name: 'Poznawaj',
    href: '/blog',
    description:
      'Masz kilkadziesiąt, kilkaset, kilka tysięcy ulubionych tytułów? Współtwórz społeczność bibliofili.',
    icon: MapIcon,
  },
];

export default function ProductDescription() {
  return (
    <div className="bg-white">
      {/* Header */}
      <div className="relative bg-gray-800 pb-32">
        <div className="absolute inset-0">
          <Image
            className="h-full w-full object-cover"
            src="https://images.unsplash.com/photo-1619641554018-8351f85d3e20?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1920&q=60&&sat=-100&auto=format&fit=crop&w=1920&q=60&&sat=-100"
            alt="Tło do opisu systemu youtalky"
            fill
          />
          <div className="absolute inset-0 bg-gray-700 mix-blend-multiply" aria-hidden="true" />
        </div>
        <div className="relative mx-auto max-w-7xl py-24 px-6 sm:py-32 lg:px-8">
          <h1 className="text-4xl font-bold tracking-tight text-white md:text-5xl lg:text-6xl">
            Czym jest YouTalky?
          </h1>
          <p className="mt-6 max-w-3xl text-xl text-gray-300">
            Portal dostępny dla każdego, kto chciałby skatalogować książki w swojej biblioteczce.
            Katalogowanie odbywa się poprzez naklejenie unikalnych kodów QR na egzemplarze
            posiadanych książek. System pozwala na śledzenie stanu Twojej biblioteczki, wymienianie
            się z innymi. Możesz ponadto sprzedając lub pożyczając książki pozostać z nimi w
            kontakcie. Każda książka dzięki naklejonemu kodowi zyskuje wirtualny sejf, który
            umożliwia dodawanie dźwięku na dany egzemplarz. Ponadto, jeśli chcesz, możesz pochwalić
            się swoim zbiorem lub powiedzieć coś o książkach.
          </p>
        </div>
      </div>

      {/* Overlapping cards */}
      <section
        className="relative z-10 mx-auto -mt-32 max-w-7xl px-6 pb-32 lg:px-8"
        aria-labelledby="contact-heading"
      >
        <h2 className="sr-only" id="contact-heading">
          Zalety
        </h2>
        <div className="grid grid-cols-1 gap-y-20 lg:grid-cols-3 lg:gap-y-0 lg:gap-x-8">
          {supportLinks.map((link) => (
            <div key={link.name} className="flex flex-col rounded-2xl bg-white shadow-xl">
              <div className="relative flex-1 px-6 pt-16 pb-8 md:px-8">
                <div className="absolute top-0 inline-block -translate-y-1/2 transform rounded-xl bg-teal-600 p-5 shadow-lg">
                  <link.icon className="h-6 w-6 text-white" aria-hidden="true" />
                </div>
                <h3 className="text-xl font-medium text-gray-900">{link.name}</h3>
                <p className="mt-4 text-base text-gray-500">{link.description}</p>
              </div>
              <div className="rounded-bl-2xl rounded-br-2xl bg-gray-50 p-6 md:px-8">
                <Link
                  href={link.href}
                  className="text-base font-medium text-teal-700 hover:text-teal-600"
                >
                  Poczytaj więcej<span aria-hidden="true"> &rarr;</span>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
